import React from 'react'
import { connect } from 'react-redux'
import { clearDocument, decreaseZoom, increaseZoom } from '../../../actions/documentViewer'
import DocumentView from './DocumentView'

/*
 *  @Description:   Wrapper component for DocumentView.
 *                  
 */


const DocumentViewWrapper = ( props ) => {
    if ( props.selectedDocument ) {
        return (
            <DocumentView
                doc={ props.selectedDocument }
                id={ props.selectedDocument.id }
                fileName={ props.selectedDocument.metadata.name }
                clearDocument={ props.clearDocument }
                zoom={ props.zoom }
                increaseZoom={ props.increaseZoom }
                decreaseZoom={ props.decreaseZoom }
            />
        )
    }
    return null
}

const mapStateToProps = ( state ) => (
    {
        selectedDocument: state.documentViewer.selectedDocument,
        zoom: state.documentViewer.zoom
    });

export default connect( mapStateToProps, { clearDocument, increaseZoom, decreaseZoom } )( DocumentViewWrapper );